define('views/modules/calendar/nutrition/food/food-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/viewport',
    'services/layout',
    'services/events/nutrition-events',
    'services/events/user-events',
    'services/i18n',
    // collections
    'collections/calendar/nutrition/foods',
    'models/calendar/nutrition/food-favorite',
    // Views
    'views/parts/menu/menu-action',
    'views/modules/calendar/nutrition/food/list/food-list',
    'views/modules/calendar/nutrition/food/edit/food-edit-modal',
    'views/modules/calendar/nutrition/food/recipe/recipe-panel',
    'views/modules/member/member/edit/member-edit-panel',
    // Templates Blocks
    'text!templates/modules/calendar/nutrition/food/food-content.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    Viewport,
    LayoutState,
    NutritionEvents,
    UserEvents,
    i18n,
    // collections
    CFoods,
    MFoodFavorite,
    // Views
    VMenuAction,
    VFoodList,
    VFoodEditModal,
    VRecipePanel,
    VMemberEditPanel,
    // Template
    TFoodContent
) {

    var VFoodContent = Backbone.View.extend({
        template: TFoodContent,
        regions: {
            root: "#nutrition-food-search-content",
            menu: ".menu-actions",
            search: ".food-search",
            list: ".lists",
            more: ".load-button"
        },
        constructor: function(options) {
            options = options || {};
            this.options = options;
            // apply defaults to child
            var proto = VFoodContent.prototype;

            _.extend(this, {
                regions: _.extend(proto.regions, this.regions),
                favorite: options.favorite,
                selected: new CFoods(),
                actions: new Backbone.Collection([
                    { title: i18n.t('messages:tooltip-create-food'), itemClass: 'big-action', content: '<strong>+</strong>', skipTranslation: 'true', callback: this.onAddFoodAction },
                    { title: i18n.t('messages:tooltip-add-food-to-meal'), content: "calendar:Add selected food", itemClass: 'pull-right', icon: 'fa fa-check', callback: this.onAddSelectedFoodAction }
                ])
            });

            if (options.recipe) {
                //this.actions.add({ title: 'Create a new recipe', icon: 'sl-icon-book-open', callback: this.onAddRecipeAction }, { at: 1 });
            }

            // views
            this.view = {
                menu: new VMenuAction({
                    context: this,
                    radio: false,
                    collection: this.actions,
                    onClick: this.onActionClick,
                    tooltip: {
                        container: this.regions.root,
                    }
                })
            };

            VFoodContent.__super__.constructor.apply(this, arguments);

            // additional events
            this.listenTo(this.collection, {
                'food:click': this.onFoodClick,
                'food:edit': this.onFoodEdit,
                'recipe:edit': this.onRecipeEdit
            });
        },

        render: function() {
            this.$el.empty()
                .append(Mustache.render(this.template, Mustache.getContext()));

            this.fetch();
            this.generateZones()
                .renderMenu()
                .renderList();

            return this;
        },

        renderMenu: function() {
            this.assign(this.view.menu, this.zone.$menu);
            return this;
        },

        renderList: function() {
            var viewObj = this.view,
                list = viewObj.list || (viewObj.list = this._initList());

            this.assign(list, this.zone.$list);
            return this;
        },

        _initList: function() {
            return new VFoodList({
                collection: this.collection,
                favorite: this.favorite
            });
        },

        getFoodModal: function() {
            var view = this.view,
                modal = view.create;
            if (!modal) {
                modal = view.create = new VFoodEditModal();
                this.listenTo(modal, { 'success': this.onEditSuccess });
            }
            return modal;
        },

        showEditModal: function(attrs) {
            this.getFoodModal().resetModel(attrs).render();
        },

        getRecipePanel: function() {
            var view = this.view.recipe || (this.view.recipe = new VRecipePanel());
            view.view.details.collection.reset();
            return view;
        },

        showRecipePanel: function(attrs) {
            LayoutState.stackInfo(this.getRecipePanel().resetModel(attrs));
        },

        fetch: function() {
            this.collection.getFirstPage();
        },

        unselect: function() {
            this.view.list.unselect();
        },

        /////////////
        // actions //
        /////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        onAddFoodAction: function() {
            this.getFoodModal().resetModel().render();
        },

        onAddRecipeAction: function() {
            this.showRecipePanel();
        },

        onAddSelectedFoodAction: function() {
          //recipe: false, suggestion: false
            var selected = this.selected;
            if (this.options.recipe === false) {
              NutritionEvents.addRecipeFood(selected.models);
            }
            else {
              NutritionEvents.addFood(selected.models);
            }
            selected.reset();
            this.unselect();
            if (Viewport.isMobile()) this.trigger('back');
        },

        /////////////////
        // food events //
        /////////////////
        onFoodClick: function(model, val) {
            var selected = this.selected;
            if (val) {
                selected.add(model);
            } else {
                selected.remove(model, { silent: true });
            }
        },

        onFoodEdit: function(model) {
            model.fetch({
                context: this,
                success: function() {
                    this.showEditModal(model.toJSON());
                }
            });
        },

        onRecipeEdit: function(model) {
            model.fetch({
                context: this,
                success: function() {
                    this.showRecipePanel(model.toJSON());
                }
            });
        },

        ////////////
        // events //
        ////////////
        onEditSuccess: function(model) {
            this.favorite.getFirstPage();
            // var favorite = this.collection.getFood(model.id);
            // if (!favorite) {
            //     favorite = new MFoodFavorite();
            // }
            // favorite.setFood(model.attributes);
            // favorite.set('name', model.get('name'));
            // this.collection.set(favorite, { remove: false }); // TODO: update food items
        },

    });

    return VFoodContent;
});

